import React, { Component } from "react";
import { Popover, OverlayTrigger } from "react-bootstrap";
import { gql } from "@apollo/client";

import { apolloClient } from "../../../index";
import sharedUsersIcon from "../../../assets/icons/sharedUsersIcon.svg";
import { getIntials, getName } from "../../../helper";
import ProfileWithName from "../../ListView/ListViewRows/ProfileWithName/ProfileWIthName";
import "./SharedIcon.scss";

class sharedIcon extends Component {
  state = {
    show: false,
    sharedWithList: [],
    showCount: false,
  };

  componentDidMount() {
    if(this.props.sharedItems) {
      const sharedItems = this.props.sharedItems
          .filter(
            (sharedItem) =>
              sharedItem.user.profile.role.name !== "IT Admin" &&
              sharedItem.user.profile.role.name !== "Admin"
          )
          .map((sharedItem) => {
            return {
              document: this.props.isFolder ? null : { id: this.props.itemId },
              folder: this.props.isFolder ? { id: this.props.itemId } : null,
              ...sharedItem,
            };
          });
      this.setState({
        sharedwith: [...sharedItems],
      });
    }
  }

  componentDidUpdate(prevProps) {
    const rootFolders = this.props.rootFolders;
    const prevRootFolders = prevProps.rootFolders;

    // // Check if folder id is changed -> reset subfolders
    if (
      prevProps.itemId !== this.props.itemId ||
      rootFolders !== prevRootFolders ||
      this.props.sharedItems !== prevProps.sharedItems
    ) {
      if (this.props.sharedItems) {
        const sharedItems = this.props.sharedItems
          .filter(
            (sharedItem) =>
              sharedItem.user.profile.role.name !== "IT Admin" && sharedItem.user.profile.role.name !== "Admin"
          )
          .map((sharedItem) => {
            return {
              document: this.props.isFolder ? null : { id: this.props.itemId },
              folder: this.props.isFolder ? { id: this.props.itemId } : null,
              ...sharedItem,
            };
          });
        this.setState({
          sharedWithList: [...sharedItems],
          showCount: this.props.showCount ?? false,
        });
      }
    }
  }

  getList = () => {
    const variables = {
      itemId: this.props.itemId,
    };

    apolloClient
      .query({
        query: this.props.isFolder
          ? gql`
              query folderSharedWith($itemId: UUID!) {
                folderSharedWith(folderId: $itemId) {
                  folder {
                    id
                  }
                  user {
                    id
                    firstName
                    lastName
                    profile {
                      image
                    }
                  }
                  userRole {
                    name
                  }
                }
              }
            `
          : gql`
              query documentSharedWith($itemId: UUID!) {
                documentSharedWith(documentId: $itemId) {
                  document {
                    id
                  }
                  user {
                    id
                    firstName
                    lastName
                    profile {
                      image
                    }
                  }
                  userRole {
                    name
                  }
                }
              }
            `,
        variables: variables,
      })
      .then((result) => {
        const sharedWithList = this.props.isFolder ? result.data.folderSharedWith : result.data.documentSharedWith;
        this.setState({ sharedWithList, show: true });
      })
      .catch((e) => console.log("****"));
  };

  getUserCountString = () => {
    const usersCount = this.state.sharedWithList ? this.state.sharedWithList.length : 0; 
    let usersCountString = "";
    if (usersCount === 0) {
      usersCountString = "Not shared";
    } else if (usersCount === 1) {
      usersCountString = "1 User";
    } else {
      usersCountString = `${usersCount} Users`;
    }
    return <div className="text">{usersCountString}</div>;
  };

  handleOnMouseEnter = () => {
    if(this.props.showCount) {
      this.setState({show: true})
    }
  }

  handleOnMouseLeave = () => {
    if(this.props.showCount) {
      this.setState({show: false})
    }
  }

  render() {
    return (
      <OverlayTrigger
        trigger={!this.props.showCount ? ["click"] : null}
        transition={null}
        key={this.props.itemId}
        placement={this.props.position ? this.props.position : "bottom"}
        {...{show: this.props.showCount ? this.state.show : undefined}}
        // show={this.props.showCount ? this.state.show : null}
        // show={this.state.show}
        overlay={
          <Popover id="popover-basic" onMouseEnter={this.handleOnMouseEnter} onMouseLeave={this.handleOnMouseLeave}>
            <Popover.Content className="shared-list">
              <div>
                {this.state.sharedWithList ? this.state.sharedWithList.length > 0 ? (
                  this.state.sharedWithList.map((item) => {
                    return (
                      <div className="pb-2" key={Math.random()}>
                        <ProfileWithName
                          sKey={item.id}
                          nameIntial={getIntials(item.user)}
                          personName={getName(item.user)}
                          profile={item.user.profile.image}
                          isPopover={true}
                          role={item.userRole.name}
                        />
                      </div>
                    );
                  })
                ) : (
                  <div>Not shared with anyone!</div>
                ) : (
                  <div>Not shared with anyone!</div>
                )}
              </div>
            </Popover.Content>
          </Popover>
        }
        rootClose
      >
        <div className="shared-icon" onMouseEnter={this.handleOnMouseEnter} onMouseLeave={this.handleOnMouseLeave}>
          <div className="icon" onClick={!this.props.showCount ? this.getList : null}>
            <img alt="Icon" src={sharedUsersIcon} />
          </div>
          {this.state.showCount ? this.getUserCountString() : null}
        </div>
      </OverlayTrigger>
    );
  }
}

export default sharedIcon;
